import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fetchSuspiciousActivity } from '../store/slices/authSlice';

const isEligibleRole = (user) =>
  user?.user_type === 'JetSetter' || user?.user_type === 'Airliner';

export default function useSuspiciousActivity() {
  const dispatch = useAppDispatch();
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated || !isEligibleRole(user)) {
      return;
    }
    dispatch(fetchSuspiciousActivity()).catch(() => {
      // intentionally silent - should not block app boot
    });
  }, [dispatch, isAuthenticated, user?.id, user?.user_type]);
}

